import React from 'react';
import Animator from '@starbucks-web/pattern-library/lib/components/animator';

import { usePdpContext } from '../pdp-provider';
import AvailabilityStatus from '../availability-status';
import ColumnsTemplate from '../columns-template';
import Customizations from './customizations';
import IncludedSection from './included-section';
import SizeSelector from '../size-selector';

const MainContent = () => {
  const { isCustomizing } = usePdpContext();

  return (
    <Animator animation="fadeGrow">
      {isCustomizing ? (
        <Customizations key="customization" />
      ) : (
        <ColumnsTemplate
          key="mainPDPContent"
          leftColumn={
            <React.Fragment>
              <SizeSelector />
              <AvailabilityStatus className="pb5" />
            </React.Fragment>
          }
          rightColumn={<IncludedSection />}
        />
      )}
    </Animator>
  );
};

export default MainContent;
